export const SetEventPage = (tiltle, window) => {

     window.gtag('event', 'page_view', {
        page_title: tiltle,
        page_location: window.location.href,
    })
}
